// Pure formatting utilities — no browser/Vite dependencies. Importable from
// both the webapp and the prerender build script (Node.js).
//
// Stats aggregation used to live here (computeStats) but moved to the
// seo_stats Postgres RPC. The frontend / prerender now receive a SeoStats
// blob already aggregated.

export type SeoStats = {
  total: number;
  priceMin: number | null;
  priceMax: number | null;
  priceMedian: number | null;
  yearMin: number | null;
  yearMax: number | null;
  yearMode: number | null;
  topSources: { name: string; count: number }[];
  lastUpdatedAt: string | null;  // ISO timestamp of the most recent first_seen_at
};

export const EMPTY_STATS: SeoStats = {
  total: 0,
  priceMin: null, priceMax: null, priceMedian: null,
  yearMin: null,  yearMax: null,  yearMode: null,
  topSources: [],
  lastUpdatedAt: null,
};

export function fmtBR(n: number | null | undefined): string {
  if (n == null) return "—";
  return n.toLocaleString("pt-BR");
}

export function fmtPrice(n: number | null | undefined): string {
  if (n == null) return "—";
  return `R$ ${n.toLocaleString("pt-BR")}`;
}

// FIPE stores some model names in ALL-CAPS (e.g. "COMPASS LONGITUDE").
// Title-case any token that is 5+ purely-alphabetic uppercase characters;
// shorter tokens are likely acronyms/codes (TSI, GLE, 4WD) and stay as-is.
export function fmtCarTitle(s: string | null | undefined): string {
  if (!s) return s ?? "";
  return s.replace(/\b([A-Z]{5,})\b/g, (w) => w.charAt(0) + w.slice(1).toLowerCase());
}
